var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-bookmarks flex items-center"},[_c('feather-icon',{staticClass:"p-2 cursor-pointer",attrs:{"svgClasses":['h-6 w-6 stroke-current', _vm.textColor],"icon":"MailIcon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }